import { ExcelExporter, Workbook } from '@progress/kendo-ooxml';
import { toExporterColumns } from './ExporterColumns';
var getDepth = function (data) {
    return Math.max.apply(Math, data.map(function (i) { return i.level; })) + 1;
};
/**
 * @hidden
 */
export var workbookOptions = function (options) {
    var columns = toExporterColumns(options.columns);
    var exporter = new ExcelExporter({
        columns: columns,
        data: options.data,
        filterable: options.filterable,
        groups: options.group,
        paddingCellOptions: options.paddingCellOptions,
        headerPaddingCellOptions: options.headerPaddingCellOptions,
        hierarchy: options.hierarchy ? { depth: getDepth(options.data), itemLevel: function (item) { return item.level; } } : null,
        collapsible: options.collapsible
    });
    var result = exporter.workbook();
    result.creator = options.creator;
    result.date = options.date;
    result.rtl = options.dir === 'rtl';
    return result;
};
/**
 * @hidden
 */
export var toDataURL = function (options) {
    var workbook = new Workbook(options);
    return workbook.toDataURL();
};
/**
 * @hidden
 */
export var isWorkbookOptions = function (value) {
    return value && value.sheets;
};
//# sourceMappingURL=workbook.js.map